import { useTranslation } from 'react-i18next'
import PopUpWrapper from '../PopUpWrapper/PopUpWrapper'
import React, { useState } from 'react'
import Api from '../../data'
import './PwdValidateModal.css'
import { UPDATE_CORRECT_OTP } from '../../constants/actionTypes'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'

const mapStateToProps = (state) => ({
    testStatus: state.testStatus,
    ...state,
})

const mapDispatchToProps = (dispatch) => ({
    setCorrectOTP: (payload) => {
        dispatch({ type: UPDATE_CORRECT_OTP, payload })
    },
})
const PwdValidateModal = (props) => {
    const [showError, setShowError] = useState(false)
    const [errorMsg, setErrorMsg] = useState('')
    const { t, i18n } = useTranslation()
    const handleClick = () => {
        const otp = document.getElementById('otp').value
        document.getElementById('otp').value = ''
        if (otp.trim() == '') {
            setShowError(true)
            setErrorMsg('Please provide a OTP.')
        } else {
            Api.validateOTP(otp)
                .then((res) => res.data)
                .then((res) => {
                    if (res.success == 'false') {
                        setShowError(true)
                        setErrorMsg('Please provide a valid OTP.')
                    } else {
                        props.setCorrectOTP(true)
                    }
                })
        }
    }
    return (
        <PopUpWrapper isToast={true} toastType="validate">
            <div>
                {showError ? (
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <div className="messageWrapper">{t(errorMsg)}</div>
                    </div>
                ) : null}
                <label className="Label">{t('OTP')}:</label>
                <input className="inputBox_roll" type="text" id="otp"></input>
                <button className="Button" onClick={handleClick}>
                    {'Submit'}
                </button>
            </div>
        </PopUpWrapper>
    )
}
export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(PwdValidateModal),
)
